import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DISMISS_KEY = "oakford_banner_dismissed";

export const HolidayBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetch(`${API}/banner`)
      .then((r) => r.json())
      .then((b) => {
        // Dismissal is remembered per message, so a new notice shows again.
        if (b?.enabled && localStorage.getItem(DISMISS_KEY) !== b.text) setBanner(b);
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, banner.text);
    setBanner(null);
  };

  if (!banner) return null;
  return (
    <div data-testid="holiday-banner" role="status" className="bg-navy text-parchment border-b border-gold/40">
      <div className="max-w-[1300px] mx-auto pl-6 pr-14 lg:px-10 py-2.5 relative flex items-center justify-center gap-3 text-center">
        <Megaphone size={14} className="text-gold shrink-0" />
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] leading-snug">{banner.text}</p>
        <button onClick={dismiss} aria-label="Dismiss notice" data-testid="holiday-banner-dismiss"
          className="absolute right-4 lg:right-6 top-1/2 -translate-y-1/2 p-1 text-parchment-muted hover:text-gold transition-colors">
          <X size={15} />
        </button>
      </div>
    </div>
  );
};
